import React from "react";

const TripList = ({ trips = [], selectedTrip, onTripSelect }) => {
  if (!trips.length) {
    return (
      <div className="py-6 text-center border-b border-light-grey">
        <p className="font-aileron font-normal text-xs text-dark-gray">
          No upcoming trips available on this route for the next 3 days.
        </p>
      </div>
    );
  }

  return (
    <div>
      {trips.map((trip) => (
        <div
          key={trip.id}
          onClick={() => onTripSelect(trip.id)}
          className="
            h-[40px]
            flex
            items-center
            justify-between
            px-6
            py-1
            border-b
            border-light-grey
            cursor-pointer
          "
        >
          <div className="flex items-center gap-3">
            <input
              type="radio"
              checked={selectedTrip === trip.id}
              readOnly
              className="accent-primary"
            />

            <p className="font-aileron font-semibold text-xs text-black">
              {trip.id}
            </p>
          </div>

          <div className="px-2 py-1 rounded-md bg-primary-10 h-6.5 flex items-center">
            <p className="font-poppins text-xs font-medium text-primary leading-none">
              {trip.schedule}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TripList;
